module.exports = __webpack_public_path__ + "img/purple2.d7879fd6.jpg";